import progressStorage from 'core/progressStorage';
import { getNameInitials, isMeaningful as isMeaningfulString } from 'utils/string';
import { RootAppState } from 'store/types';
import {
  isCrossDeviceSavingEnabled,
  isTrackingEnabled,
  isPublishMode
} from '../settings/selectors';

export const getUser = (state: RootAppState) => state.user;

export const getEmail = (state: RootAppState) => state.user.email;

export const getAvatarUrl = (state: RootAppState) => state.user.avatarUrl || '';

export const getName = (state: RootAppState) => state.user.name;

export const getAccount = (state: RootAppState) => state.user.account;

export const isAuthenticatedReviewer = (state: RootAppState) => state.user.isAuthenticatedReviewer;

export const isRegisteredReviewer = (state: RootAppState) => state.user.isRegisteredReviewer;

export const isAnonymous = (state: RootAppState) => !!state.user.authorizationSkipped;

export const isIntroduced = (state: RootAppState) => isMeaningfulString(getEmail(state));

export const shouldSaveCrossDevice = (state: RootAppState) =>
  isCrossDeviceSavingEnabled(state) && !isAnonymous(state);

export const isAuthenticated = (state: RootAppState) =>
  progressStorage.isAuthenticated() ||
  (!isCrossDeviceSavingEnabled(state) && isAnonymous(state)) ||
  (!isCrossDeviceSavingEnabled(state) && isTrackingEnabled(state) && isIntroduced(state)) ||
  isAnonymous(state) ||
  !isPublishMode(state) ||
  !isTrackingEnabled(state);

export const isAuthorized = (state: RootAppState) => isAuthenticated(state) && !isAnonymous(state);

export const isGuestUser = (state: RootAppState) =>
  !isCrossDeviceSavingEnabled(state) && isIntroduced(state);

export const getAvatarLetter = (state: RootAppState) =>
  (getNameInitials(state.user.name) || (state.user.email && state.user.email[0])).toUpperCase();

export const getFullName = (state: RootAppState) => state.user.name;

export const getUserId = (state: RootAppState) => btoa(state.user?.email || '');
